

import {TopupChannelService} from "@/services/topupchannel.service";

const state = {
    loading: false,
    overlay: false,
    topuplist: []
}

const actions = {
    getTopupList({ commit }) {
        commit('setloading', true);
        TopupChannelService.getTopupList().then(data => {
            commit('addtopuplist', data);
        }, error => {
            console.log(error);
        });
    },
}

const mutations = {
    setloading(state, data) {
        state.loading = data;
        state.overlay = data;
    },
    addtopuplist(state, dash) {
        state.topuplist = dash.data;
        state.loading = false;
    },
}


export const TopupChannel = {
    namespaced: true,
    state,
    actions,
    mutations
};
